/**
 * Servicio para envío de emails desde landing CER
 * Integrado con backend ASP.NET Core
 */

export class ContactoService {
    /**
     * Envía un email de contacto desde la landing page
     * @param {Object} data - { nombre, email, mensaje }
     * @returns {Promise} - Promesa que resuelve con éxito o error
     */
    static async enviarContacto(data) {
        try {
            // Mapeo del objeto del formulario al DTO del backend
            const dto = {
                Nombre: data.nombre,
                Mail: data.email,
                Mensaje: data.mensaje
            };

            const response = await fetch('/api/Contacto/EnviarContacto', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dto)
            });

            if (!response.ok) {
                // Si la respuesta no es OK, intentar obtener el mensaje de error del servidor
                const errorData = await response.json().catch(() => ({
                    mensaje: 'Error al enviar el email'
                }));

                throw new Error(errorData.mensaje || 'Error al enviar el email');
            }

            // Retornar la respuesta del servidor
            return await response.json();

        } catch (error) {
            console.error('Error al enviar email de contacto:', error);
            throw error;
        }
    }
}
